import { render, staticRenderFns } from "./MobileLink.vue?vue&type=template&id=489196ca&scoped=true"
import script from "./MobileLink.vue?vue&type=script&lang=js"
export * from "./MobileLink.vue?vue&type=script&lang=js"
import style0 from "./MobileLink.vue?vue&type=style&index=0&id=489196ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489196ca",
  null
  
)

export default component.exports